import { Component, Input } from '@angular/core';
import { IconNames } from '@shared/enums/icon-names';
import { PriceType } from '@shared/pipes/price-format.pipe';
import { PriceFormatPipe } from '../../pipes/price-format.pipe';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-customer-agreement',
  templateUrl: './customer-agreement.component.html',
  styleUrls: ['./customer-agreement.component.scss'],
  imports: [NgClass, MatIcon, MatIconButton, MatMenuTrigger, MatMenu, PriceFormatPipe],
})
export class CustomerAgreementComponent {
  IconNames = IconNames;
  PriceType = PriceType;

  @Input() iconName: string;
  @Input() hasIcon: boolean = true;
  @Input() mainHeading: string;
  @Input() subHeading: string;
  @Input() monthlyPrice: number;
  @Input() isInFlightOrder: boolean = false;
  @Input() hasNavigation: boolean = true;
  @Input() isFamilyBenefit: boolean = false;
  @Input({ required: false }) originalPrice = 0;
}
